<template>
    <div class="detail-page-controls" >
        <div class="detail-page-controls__inner">
            <a  v-if="nav.prev"
                :href="nav.prev.link"
                class="detail-page-controls__nav detail-page-controls__nav--prev"
                ref='prevBtn'
            >
                <z-icon
                    name="btn-arrow"
                    width="16"
                    height="16"
                />
                <span v-html="nav.prev.name" class="detail-page-controls__nav-text"></span>
            </a>
            <a  v-if="nav.next"
                :href="nav.next.link"
                class="detail-page-controls__nav detail-page-controls__nav--next"
                ref='nextBtn'
            >
                <span v-html="nav.next.name" class="detail-page-controls__nav-text"></span>
                <z-icon
                    name="btn-arrow"
                    width="16"
                    height="16"
                />
            </a>
        </div>
    </div>
</template>

<script>

export default {
    name: 'detail-page-prev-next-controls',
    props: {
        nav: {
            type: Object
        }
    }
}
</script>

<style lang="scss">
.detail-page-controls {
    padding-top: 32px;
    margin-top: 48px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);

    &__inner {
        display: flex;
        justify-content: space-between;
    }

    &__nav {
        display: flex;
        align-items: center;
        text-decoration: none;
        color: $token-colors-black;
        text-transform: uppercase;
        font-size: 14px;
        line-height: 1.2;

        &:hover {
            text-decoration: underline;
        }

        .z-icon path {
            fill: #E42213;
        }

        &--prev {
            margin-right: auto;
            .z-icon {
                margin-right: $token-spacers-xs;
                transform: scale(-1, 1);
            }
        }

        &--next {
            margin-left: auto;
            text-align: right;

            .z-icon {
                margin-left: $token-spacers-xs;
            }
        }
    }

    &__nav-text {
        margin-top: 0.1em;
    }
}
</style>
